function touchMoveEvent(e) {
    e.preventDefault();
}

const Helper = {
    'disableTouchMove': () => {
        document.body.addEventListener('touchmove', touchMoveEvent, { passive: false });
    },
    'enableTouchMove': () => {
        document.body.removeEventListener('touchmove', touchMoveEvent);
    }
};

export default Helper;